export default __webpack_public_path__ + "static/media/454.48fdc2cc.gif";